$(function () {
  $('body').on('click', '#new_tag', function (e) {
    $('#tag_form').show();
  });

  $('body').on('click', '#close_tag', function (e) {
    $('#tag_form').hide();
  });
});
